import { Breadcrumb, Button, Card, Col, Flex, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg"
import TableAntd from "components/elements/Table";
import OvertimeReportModal from "../reportModal/OvertimeReportModal";
import moment from "moment";

const OvertimeReportComponent = ({
    pagination,
    showReport,
    positionOptions = [],
    departmentOptions = [],
    employmentTypeOptions = [],
    isModalOpen = false,
    rePortTableOvertime = [],
    handleSearch = () => { },
    setIsModalOpen = () => { },
    handleDateChange = () => { },
    showModal = () => { },
    exportOvertimeReport = () => { },
    onChange = () => { }
}) => {
    const { t, i18n } = useTranslation();

    const columns = [
        {
            title: <div className="text-table">{t('report.employeeNo')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "center",
            width: 130,
            render: (_, record) => {
                if (record?.employeeNo === null || record?.employeeNo === undefined || record?.employeeNo === "") {
                    return "-";
                }
                return <span
                    style={{
                        color: "#42526D",
                        backgroundColor: "#F5F6F7",
                        borderRadius: "20px",
                        width: "max-content",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "auto",
                        padding: "8px 16px"
                    }}
                >
                    {record?.employeeNo}
                </span>;
            },
        },
        {
            title: <div className="text-table">{t('name-surname')}</div>,
            dataIndex: "name",
            key: "name",
            align: "left",
            width: 250,
            render: (_, record) => {
                return (record?.name ?
                    (i18n.language === "en" ? record?.nameEn + " " + record?.surNameEn : record?.name + " " + record?.surName) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('department')}</div>,
            dataIndex: "department",
            key: "department",
            align: "left",
            width: 250,
            render: (_, record) => {
                return (
                    record?.department?.id ? (i18n.language === "en" ? record?.department?.nameEn : record?.department?.name) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('report.position')}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            width: 300,
            render: (_, record) => {
                return (
                    record?.position?.id ? (i18n.language === "en" ? record?.position?.nameEn : record?.position?.name) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('employment-type')}</div>,
            dataIndex: "employmentType",
            key: "employmentType",
            width: 200,
            align: "left",
            render: (_, record) => {
                return (
                    record?.employmentType?.id ? (i18n.language === "en" ? record?.employmentType?.nameEn : record?.employmentType?.name) : "-"
                )
            },
        },
    ]
    return (
        <MainLayout>
            <OvertimeReportModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} exportOvertimeReport={exportOvertimeReport} />
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("report.header"), href: "" },
                        { title: t("working_time_group.header"), href: "" },
                        { title: t("overtime_report.header") }
                    ]} />
                    <h2>{t("overtime_report.header")}</h2>
                </Flex>

                <FormAntd onFinish={handleSearch}>
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card
                                        style={{
                                            backgroundColor: "white",
                                            width: "100%",
                                            marginBottom: "1vw",
                                            border: "1px solid #EAECF0",
                                        }}
                                    >
                                        <Flex vertical gap={16}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t("name-surname")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormSelect
                                                        name="departmentId"
                                                        label={t('employee.label.department')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="positionId"
                                                        label={t('position.header')}
                                                        options={positionOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="employmentTypeId"
                                                        label={t("salary.label.employment_type")}
                                                        size="large"
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.please_select')}
                                                        options={employmentTypeOptions}
                                                        required
                                                        mode="multiple"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="startToEndDate"
                                                        type="range"
                                                        label={t('start-date-to-end-date')}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('start-work-date-to-end-date')}
                                                        size="large"
                                                        onChange={handleDateChange}
                                                        required
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px", marginTop: "24px" }}>
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>
                                    {showReport && (
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Flex justify="end">
                                                <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                    <Flex gap={8}>
                                                        <DownloadIcon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>
                                            <Card style={{
                                                backgroundColor: "white",
                                                width: "100%",
                                                border: "1px solid #EAECF0",
                                            }}>
                                                <Space direction="vertical" size={8} style={{ width: "100%" }}>
                                                    <span style={{ fontSize: "1vw", fontWeight: "bold" }}>{t('overtime_report.header')}</span>
                                                    <TableAntd
                                                        onChange={onChange}
                                                        pagination={pagination}
                                                        columns={columns}
                                                        dataSource={rePortTableOvertime}
                                                        rowKey={(record) => record.id}
                                                    />
                                                </Space>
                                            </Card>
                                        </Space>
                                    )}
                                </>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout>
    )
}

export default OvertimeReportComponent;